/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useEffect, useLayoutEffect } from 'react'

/**********************************************************************************************************
 *   HOOK
 **********************************************************************************************************/
export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect
